import { createRouter, createWebHistory } from 'vue-router'
import Main from '../views/Main.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: Main,
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('../views/Home.vue')
        },
        {
          path: 'characters',
          name: 'Characters',
          component: () => import('../views/Characters.vue')
        },
        {
          path: 'wallet',
          name: 'Wallet',
          component: () => import('../views/Wallet.vue')
        },
        {
          path: 'profile',
          name: 'Profile',
          component: () => import('../views/Profile.vue')
        },
        {
          path: 'stone-game',
          name: 'StoneGame',
          component: () => import('../views/StoneGame.vue')
        }
      ]
    },
    {
      path: '/chat/:characterId?',
      name: 'Chat',
      component: () => import('../views/Chat.vue'),
      props: true
    }
  ]
})

export default router
